import type { AuthorizedResource } from '@/services/bff/permission.api';

export type AuthorizedResourceAccessMap = Record<string, boolean>;
export const isAuthorizedResourceAllowed = (effect?: string | null) =>
  effect?.toUpperCase() === 'ALLOW';

export function buildAuthorizedResourceAccessMap(
  resources: AuthorizedResource[] = [],
): AuthorizedResourceAccessMap {
  const access: AuthorizedResourceAccessMap = {};
  for (const resource of resources) {
    if (
      !resource.code ||
      !isAuthorizedResourceAllowed(resource.effect) ||
      resource.condition
    )
      continue;
    access[resource.code] = true;
    for (const action of resource.actions ?? [])
      access[`${resource.code}:${action}`] = true;
  }
  for (const resource of resources) {
    if (!resource.code || resource.effect?.toUpperCase() !== 'DENY') continue;
    if (!resource.actions?.length) {
      access[resource.code] = false;
      for (const key of Object.keys(access))
        if (key.startsWith(`${resource.code}:`)) access[key] = false;
    } else {
      for (const action of resource.actions)
        access[`${resource.code}:${action}`] = false;
    }
  }
  return access;
}
